import {Container} from "react-bootstrap";
import React from "react";
import {Link} from "react-router-dom";
import imgInstagram from "../../../../images/btns-social/instagram_black_icon.png";
import imgWhatsapp from "../../../../images/btns-social/whatsapp_black_icon.png";
import {FRUITMRUIT_WHATSAPP_WEB, FRUITMRUIT_INSTAGRAM, FRUITMRUIT_SUPPORT_PHONE} from "../../../../apis";

import Fab from '@mui/material/Fab';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const ShortFooter = () => {
    return (
    	<Container className="pt-5">
	        <div className="row border-top pb-4 pt-3" id="short-footer">
	            <div className="col-xs-12 col-sm-12 col-md-6 m-auto">
	            	<div className="row">
	            		<Link to={`/more-pages/contact-us`} className="col-4 col-lg-3 text-left" > ارسال پیام </Link>
	            		<Link to={`/more-pages/rules`} className="col-4 col-lg-3 text-center" > قوانین و مقررات </Link>
	            		<Link to={`/intro`} className="col-4 col-lg-3 text-right" > راهنمایی؟ </Link>
	            	</div>
	            		

                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 text-right mt-4 mt-md-0">
                	<Link to="#!" onClick={() =>window.open(FRUITMRUIT_INSTAGRAM)}>
                		<img src={imgInstagram} className="mr-3" alt="instagram" width="30" />
                	</Link>
                	<Link to="#!" onClick={() =>window.open(FRUITMRUIT_WHATSAPP_WEB)}>
                		<img src={imgWhatsapp} alt="whatsapp" width="30" />
            		</Link>
                </div>
	        </div>

            <a href={`whatsapp://send?phone=${FRUITMRUIT_SUPPORT_PHONE}`}>
                <Fab 
                    color="#42b029" 
                    sx={{
                        color: 'white',
                        fontFamily: 'IYekan', 
                        '&.MuiFab-root' : { position: 'fixed', bottom: '5px', right: '5px', transform: 'translate(-50%, -50%)',  backgroundColor: '#42b029', zIndex: '1'}
                    }}
                    aria-label="whatsapp">
                    <WhatsAppIcon />
                </Fab>
            </a>

        </Container>
    );
};
export default ShortFooter;
